import { Link } from 'react-router-dom';

interface SiteChromeProps {
  children: React.ReactNode;
  /** Hides the top nav on funnel screens (scanning + quote) to keep eyes on the flow. */
  hideNav?: boolean;
}

export function SiteChrome({ children, hideNav }: SiteChromeProps) {
  return (
    <>
      <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-bold text-xl tracking-tight">
          Digadop <span className="text-blue-600">AI</span>
        </Link>
        {!hideNav && (
          <nav className="hidden md:flex gap-6 text-sm text-slate-700">
            <a href="#" className="hover:text-slate-900">
              Pricing
            </a>
            <a href="#" className="hover:text-slate-900">
              Blog
            </a>
            <Link to="/app" className="hover:text-slate-900">
              Sign in
            </Link>
          </nav>
        )}
      </header>
      <main>{children}</main>
      <footer className="mt-24 border-t border-slate-200 px-6 py-8 text-sm text-slate-500">
        <div className="max-w-6xl mx-auto flex flex-wrap gap-6 justify-between">
          <div>© 2026 Digadop AI</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-slate-700">
              Privacy
            </a>
            <a href="#" className="hover:text-slate-700">
              Terms
            </a>
            <a href="#" className="hover:text-slate-700">
              Data scope
            </a>
            <a href="#" className="hover:text-slate-700">
              Revoke access
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
